import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

const CreateEventsModal = ({
  showEventModal,
  handleClose,
  leadList,
  funnalStages,
  onSubmit,
  setEventModal,
  eventFormData,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      leadId: eventFormData?.leadId,
      leadStatus: eventFormData?.leadStatus,
      eventDescription:"",
    },
  });

  useEffect(() => {
    if (eventFormData) {
        if (eventFormData) {
    reset({
       leadId: eventFormData?.leadId,
      leadStatus: eventFormData?.leadStatus,
      eventStatus: "0",
      eventDate: null,
      eventDescription: "",
    });
  }
    }
  }, [eventFormData, reset]);

  const eventDate = watch("eventDate");

  return (
    <div>
      <Modal
        id="addfollowup"
        show={showEventModal}
        onHide={() => setEventModal(!showEventModal)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* Lead Name */}
            <Form.Group className="form-group">
              <Form.Label>Lead Name</Form.Label>
              <Form.Select
                {...register("leadId", { required: "Lead is required" })}
                disabled
              >
                <option value="">Select Lead</option>
                {leadList?.map((lead, index) => (
                  <option value={lead["CrmLeads.id"]} key={index}>
                    {lead["CrmLeads.firstName"] +
                      " " +
                      lead["CrmLeads.lastName"]}
                  </option>
                ))}
              </Form.Select>
              {errors.leadId && (
                <span className="validation-error-message">
                  {errors.leadId.message}
                </span>
              )}
            </Form.Group>

            {/* Event Type */}
            <Form.Group className="form-group">
              <Form.Label>Event Type</Form.Label>
              <Form.Select
                {...register("leadStatus", {
                  required: "Event type is required",
                })}
                disabled
              >
                <option value="">Select Event</option>
                {funnalStages?.length > 0 ? (
                  funnalStages
                    .filter((funObj) => funObj.eventStatus)
                    .map((funObj) => (
                      <option key={funObj.id} value={funObj.id}>
                        {funObj.name}
                      </option>
                    ))
                ) : (
                  <option disabled>No stages available</option>
                )}
              </Form.Select>
              {errors.leadStatus && (
                <span className="validation-error-message">
                  {errors.leadStatus.message}
                </span>
              )}
            </Form.Group>

            {/* Description */}
            <Form.Group className="form-group">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                {...register("eventDescription", {
                  required: "Description is required",
                })}
              />
              {errors.eventDescription && (
                <span className="validation-error-message">
                  {errors.eventDescription.message}
                </span>
              )}
            </Form.Group>

            {/* Event Date */}
            <Form.Group className="form-group">
              <Form.Label>Event Date</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  {...register("eventDate", {
                    required: "Event Date is required",
                  })}
                  className="form-control"
                  // value={eventDate || null}
                  // onChange={(date) =>
                  //   setValue("eventDate", date, { shouldValidate: true })
                  // }
                  minDate={dayjs()}
                  ampm
                  value={eventDate ? dayjs(eventDate) : null} // Ensure it's a Day.js object
                  onChange={
                    (date) =>
                      setValue("eventDate", dayjs(date), {
                        shouldValidate: true,
                      }) // Convert before saving
                  }
                />
              </LocalizationProvider>
              {errors.eventDate && (
                <span className="validation-error-message">
                  {errors.eventDate.message}
                </span>
              )}
            </Form.Group>
            {/* Event Status */}
            <Form.Group className="form-group">
              <Form.Label>Event Status</Form.Label>
              <Form.Select
                {...register("eventStatus", {
                  required: "Event status is required",
                })}
              >
                <option value="">Select Status</option>
                <option value="0" selected>
                  Pending
                </option>
                {/* <option value="1">Completed</option>
                <option value="2">Canceled</option> */}
              </Form.Select>
              {errors.eventStatus && (
                <span className="validation-error-message">
                  {errors.eventStatus.message}
                </span>
              )}
            </Form.Group>

            {/* Buttons */}
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Add Event
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateEventsModal;
